import React, { useEffect, useRef, useState } from "react";
import AceEditor from "react-ace";
import { FakeJava } from "../../../FakeData/FakeData";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";
import PropTypes from "prop-types";

// PropTypes validation
CodeEditor.propTypes = {
  highlightLine: PropTypes.number.isRequired,
};

function CodeEditor({ highlightLine }) {
  const editorRef = useRef(null);
  const [code] = useState(FakeJava);

  useEffect(() => {
    if (editorRef.current && highlightLine !== null && highlightLine > 0) {
      const editor = editorRef.current.editor;
      editor.gotoLine(highlightLine, 0, true);
    }
  }, [highlightLine]);

  return (
    <div>
      <AceEditor
        mode="java"
        theme="monokai"
        name="ace-editor"
        fontSize={12}
        ref={editorRef}
        width="100%"
        height="100%"
        value={code}
        readOnly={true}
      />
      
    </div>
  );
}

export default CodeEditor;
